<div fxLayout="row">
    <dl-device-reader-status [item]="item"></dl-device-reader-status>
    <div fxFlex></div>
</div>
